export const parseHorizontalGeometry = (data) =>
{
    let parsedGeometry = [];
    data = data.trim().split("\n");
    data.forEach(el => {
        let object = el.trim().split("\t")
        let temp = {};

        temp.number = Number(object[0]);
        temp.type = object[1];
        temp.startStationing = Number(object[2]);
        temp.endStationing = Number(object[3]);
        temp.firstRadius = Number(object[4]);
        temp.secondRadius = Number(object[5]);
        temp.clothoideParameter = temp.type === 'Klotoide' ? Number(object[12]) : null;
        temp.length = Number(object[7]);
        temp.directionChange = 0;
        temp.eastStart = Number(object[14]);
        temp.northStart = Number(object[15]);
        temp.eastEnd = Number(object[16]);
        temp.northEnd = Number(object[17]);
        
        if(temp.type === "Sirkelbue") temp.mergedRadius = Number(object[4]);
        if(temp.type === "Klotoide") temp.mergedRadius = Number(object[4]) + ' / ' + Number(object[5]);
        
        if(temp.type === "Sirkelbue") temp.directionChange = (180 * temp.length)/(Math.abs(temp.firstRadius) * Math.PI);
        else if(temp.type === "Klotoide")
        {
            if((temp.firstRadius === 0 && temp.secondRadius !== 0) || (temp.firstRadius !== 0 && temp.secondRadius === 0)) temp.directionChange = (1/Math.max(Math.abs(temp.firstRadius), Math.abs(temp.secondRadius))) * temp.length/2;
            else if(temp.firstRadius !== 0 && temp.secondRadius !== 0) temp.directionChange = (1/Math.abs(temp.firstRadius) + 1/Math.abs(temp.secondRadius)) * temp.length/2;
        }

        parsedGeometry.push(temp);
    });

    let parseTestResult = true;

    for(let i = 0; i < parsedGeometry.length; i++)
    {
        if(parsedGeometry[i].type)
        {
            if(parsedGeometry[i].type !== "Rettlinje" && parsedGeometry[i].type !== "Sirkelbue" && parsedGeometry[i].type !== "Klotoide") parseTestResult = false;
        }
        else parseTestResult = false;

        if(parsedGeometry[i+1] && parseTestResult)
        {
            if(parsedGeometry[i].number !== parsedGeometry[i+1].number - 1) parseTestResult = false;
            if(parsedGeometry[i].endStationing !== parsedGeometry[i+1].startStationing) parseTestResult = false
            if(parsedGeometry[i].endElevation !== parsedGeometry[i+1].startElevation) parseTestResult = false
        }
    }

    if(parseTestResult) return parsedGeometry;
    else return null;
}